import { createReduxAsyncThunk } from 'shared/utils';
import { countriesAPI } from '../../api';

import { COUNTRIES_STATE } from '../../constants';

import { CountriesState } from '../../types';

export const getAvoidedCountries = createReduxAsyncThunk<CountriesState['avoidedCountries']['data']>(
  `${COUNTRIES_STATE}/getAvoidedCountries`,
  async () => {
    const { data } = await countriesAPI.getAvoidedCountries();
    return data;
  }
);